export enum ResourceType{
    UserAccount,
    UserBilling,
    TenantAccount,
    TenantMember
}